import React, { Component } from 'react';
import './ChatRooms.css';
import firebase from '../firebase';

class ChatRooms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatRoomsList: [],
      isRoomBeingCreated: false,
      newRoomName: '',
    };
  }

  componentDidMount() {
    const dbRef = firebase.database().ref(`/ChatRooms/`);
    dbRef.on('value', snapshot => {
      this.setState({
        chatRoomsList: Object.keys(snapshot.val()),
      });
    });
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref(`/ChatRooms/`)
      .off();
  }

  handleClick = () => {
    this.setState({
      isRoomBeingCreated: true,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { chatRoomsList, newRoomName } = this.state;
    if (/\S/.test(newRoomName)) {
      firebase
        .database()
        .ref(`/ChatRooms/${newRoomName}/Messages`)
        .push({
          content: `New ${newRoomName} room succesfully created!`,
          author: 'Admin',
          date: new Date().getTime(),
        });
      this.setState({
        chatRoomsList: [newRoomName, ...chatRoomsList],
        newRoomName: '',
        isRoomBeingCreated: false,
      });
    } else {
      this.setState({
        newRoomName: '',
        isRoomBeingCreated: false,
      });
    }
  };

  handleChange = e => {
    this.setState({
      newRoomName: e.target.value,
    });
  };

  render() {
    const { chatRoomsList, newRoomName, isRoomBeingCreated } = this.state;
    return (
      <div
        className={
          this.props.mobileRooms
            ? `chat-rooms active-mobile-chat-rooms`
            : `chat-rooms`
        }
      >
        <div className="chat-rooms-list">
          {chatRoomsList.map((element, index) => (
            <button
              type="submit"
              key={element}
              id={index}
              name={element}
              onClick={this.props.changeRoom}
              className={
                this.props.room === element
                  ? 'chat-rooms-item selected'
                  : 'chat-rooms-item'
              }
            >
              {element}
            </button>
          ))}
        </div>
        {isRoomBeingCreated ? (
          <form className="create-room-form">
            <input
              className="create-room-input"
              type="text"
              placeholder="enter room's name"
              value={newRoomName}
              onChange={this.handleChange}
            />
            <button
              className="create-room-submit"
              type="submit"
              onClick={this.handleSubmit}
            >
              Add Room
            </button>
          </form>
        ) : (
          <button
            className="create-room-trigger"
            type="submit"
            onClick={this.handleClick}
          >
            <span>+</span> New room
          </button>
        )}
      </div>
    );
  }
}

export default ChatRooms;
